export type ToastType = 'info' | 'success' | 'warning' | 'error';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
  duration: number | 'persistent';
  action?:
    | {
        label: string;
        onPress: () => void;
      }
    | undefined;
}

type Listener = (toasts: Toast[]) => void;

class ToastStore {
  private toasts: Toast[] = [];
  private listeners: Set<Listener> = new Set();
  private nextId = 0;

  show(
    message: string,
    options: {
      type?: ToastType;
      duration?: number | 'persistent';
      action?: { label: string; onPress: () => void };
    } = {},
  ): string {
    const id = `toast-${this.nextId++}`;
    const toast: Toast = {
      id,
      type: options.type ?? 'info',
      message,
      duration: options.duration ?? 4000,
      action: options.action,
    };

    this.toasts = [...this.toasts, toast];
    this.notify();
    return id;
  }

  remove(id: string): void {
    this.toasts = this.toasts.filter((t) => t.id !== id);
    this.notify();
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    listener(this.toasts);
    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    for (const listener of this.listeners) {
      listener(this.toasts);
    }
  }
}

export const toastStore = new ToastStore();
